/**
 * Helpers to display the first 8 characters of an internal system ID
 * next to a human-readable name. Used everywhere we show a collector or
 * facility (records, history tables, detail popups, exports).
 *
 *   shortId("4a7f8c3b-1234-5678-9abc-def012345678") // → "4a7f8c3b"
 *   idSuffix(id)                                     // → " (ID: 4a7f8c3b)"
 *   nameWithId("Hong Zheng Plastic", id)             // → "Hong Zheng Plastic (ID: 4a7f8c3b)"
 *
 * Always handles missing / null ids gracefully (returns the bare name).
 */
export function shortId(id) {
  if (!id) return "";
  return String(id).slice(0, 8);
}

export function idSuffix(id) {
  const s = shortId(id);
  return s ? ` (ID: ${s})` : "";
}

export function nameWithId(name, id) {
  const cleanName = (name || "").toString().trim();
  const suf = idSuffix(id);
  if (!cleanName && !suf) return "—";
  if (!cleanName) return suf.slice(1); // trim leading space
  return `${cleanName}${suf}`;
}
